/* eslint-disable jsx-a11y/alt-text */
import { getAccessTokenSilently } from "utils/functions";
import { TableContainer } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import { CircularProgress } from "@mui/material";
import Button from "components/button/Button";
import MemberService from "Lib/API/Member";
import React, { useState } from "react";
import { toastr } from "react-redux-toastr";
import "./index.scss";
import { Fonts, FontFamilies, FontColors } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: FontFamilies.General,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: Fonts.GeneralBodyFont.fontFamily,
    fontSize: Fonts.GeneralBodyFont.fontSize,
    color: FontColors.Slate4D5565,
  },
}))(TableCell);

const AvailableClassList = () => {
  const isMobile = useMediaQuery("(max-width:600px)");
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const [count, setCount] = useState();

  const [page, setPage] = useState(0);

  const enableLoading = (value) => {
    setLoading(value);
  };
  async function getClassesList() {
    enableLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const payload = {
        isMember: false,
      };
      const result = await MemberService.getClassesList(
        token,
        page + 1,
        30,
        localStorage.getItem("orgId"),
        payload
      );
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const filtered = (result?.payload?.data || []).filter((row) =>
        row?.always_available || !row?.class_end_date || new Date(row.class_end_date) >= today
      );
      setList(filtered);
      setCount(filtered.length);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      enableLoading(false);
    }
  }
  React.useEffect(() => {
    getClassesList();
  }, [page]);

const checkClassIsFull = (row) => {
    const totalParticipants = row?.participantsDetails?.total;
    const maximumParticipants = row?.class_details?.maximum_participants;
    return !row?.infiniteParticipants
      ? totalParticipants >= maximumParticipants
      : false;
  };

  const displayRegistrationBtnText = (row) => {
    let text = " Sign up";
    const isClassFull = checkClassIsFull(row);

    if (isClassFull && row?.allow_waiting_List && row?.isFull) {
      text = "Join Wait List";
    } else if (isClassFull) {
      text = "Class is Full";
    } else {
      text = "Sign up";
    }
    return text;
  };

  if (loading) return (
    <div style={{ display: "flex", justifyContent: "center", padding: 40 }}>
      <CircularProgress />
    </div>
  );

  if (!list?.length) return (
    <div style={{ textAlign: "center", padding: "60px 0", color: FontColors.Slate64748B, fontFamily: FontFamilies.General }}>
      No Classes Found
    </div>
  );

  return (
    <div className="w-100 school_class_list mt-4">
      <div className={"family-table-container"}>
        <div className="current-class-table-container">
          {isMobile ? (
            <div style={{ padding: "12px 16px", display: "flex", flexDirection: "column", gap: 12 }}>
              {list.map((row, i) => (
                <div key={i} style={{
                  background: "#fff", borderRadius: 12, border: "1px solid #E2E8F0",
                  padding: "12px 16px",
                }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, marginBottom: 4 }}>
                    <div style={{ ...Fonts.GeneralSubHeaderFont, color: FontColors.Slate0F172A, minWidth: 0 }}>
                      {row?.class_name}
                    </div>
                    <div style={{ flexShrink: 0 }}>
                      <Button
                        disabled={checkClassIsFull(row)}
                        onClick={() => window.location.replace(`${window.location.origin}/school/${row?._id}`)}
                        variant="primary"
                        style={{ minWidth: "90px", height: 34, borderRadius: 32 }}
                        size="md"
                      >
                        {displayRegistrationBtnText(row)}
                      </Button>
                    </div>
                  </div>
                  <div style={{ fontFamily: Fonts.GeneralSmallBodyFont.fontFamily, fontSize: Fonts.GeneralSmallBodyFont.fontSize, color: FontColors.Slate64748B }}>
                    {[row?.year, (row?.class_details?.ageStart != null && row?.class_details?.ageEnd != null) ? `Age: ${row.class_details.ageStart} – ${row.class_details.ageEnd}` : null].filter(Boolean).join(" · ")}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div style={{ padding: "17px" }}>
              <TableContainer className="scroll-table">
                <Table aria-label="collapsible table">
                  <TableHead className="charges-table sticky-table-header">
                    <TableRow>
                      <TableCellHead className="class__header__cell className_head">
                        <div>CLASS NAME</div>
                      </TableCellHead>
                      <TableCellHead align="left" className="class__header__cell year__head">
                        <div>YEAR</div>
                      </TableCellHead>
                      <TableCellHead align="left" className="class__header__cell ageRane__head">
                        <div>AGE RANGE</div>
                      </TableCellHead>
                      <TableCellHead align="left" className="class__header__cell" />
                    </TableRow>
                  </TableHead>
                  <TableBody style={{ backgroundColor: "white" }}>
                    {list.map((row, i) => (
                      <React.Fragment key={i}>
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }} className="class_tableRow">
                          <TableCellBody className="status-head main-width-class" component="th" scope="row">
                            <div className="school-table-className">{row?.class_name}</div>
                          </TableCellBody>
                          <TableCellBody className="main-width-class" align="left">
                            <div className="school-table-year">{row?.year}</div>
                          </TableCellBody>
                          <TableCellBody className="main-width-class" align="left">
                            <div className="school-table-dateRange">
                              {row?.class_details?.ageStart} - {row?.class_details?.ageEnd}
                            </div>
                          </TableCellBody>
                          <TableCellBody className="main-width-class" align="right">
                            <Button
                              disabled={checkClassIsFull(row)}
                              onClick={() => window.location.replace(`${window.location.origin}/school/${row?._id}`)}
                              variant="primary"
                              style={{ minWidth: "90px", height: 34, borderRadius: 32 }}
                              size="md"
                            >
                              {displayRegistrationBtnText(row)}
                            </Button>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      </div>
      <div className="pagination-custom" style={{ marginTop: 16 }}>
        <Pagination
          count={Math.ceil(count / 30)}
          color="primary"
          variant="outlined"
          page={page + 1}
          onChange={(event, value) => {
            setPage(value - 1);
          }}
        />
      </div>
    </div>
  );
};

export default AvailableClassList;
